import { ProtocolMode } from '@azure/msal-browser';
import { ApplicationEnvironment } from './environment.interface';

export const environment: ApplicationEnvironment = {
  production: false,
  apiConfig: {
    baseUrlAgent: 'https://api-dev.vision.zeiss.com/public/api/lr/agents/v1',
    baseUrlBackend: 'https://api-dev.vision.zeiss.com/public/api/lr/backend/v1',
    scopes: ['db344942-be91-4f63-b36a-fb4d823f8187'],
    loginFailedRoute:
      'https://id-ip-stage.zeiss.com/b2c_1a_zeissidnormalsignin',
    subscriptionKeyAgent: '68847d4c7ea540f58298fcba46541fc5',
    subscriptionKeyBackend: 'c4b69266661e456a9a23948b9e7441a8',
  },
  msalConfig: {
    auth: {
      clientId: 'db344942-be91-4f63-b36a-fb4d823f8187',
      authority: 'https://id-ip-stage.zeiss.com/b2c_1a_zeissidnormalsignin',
      knownAuthorities: ['id-ip-stage.zeiss.com'],
      protocolMode: ProtocolMode.OIDC,
      postLogoutRedirectUri: window.location.origin,
      redirectUri: window.location.origin,
    },
  },
};
